import { makeStyles } from '@material-ui/core/styles';

const productsAlreadyScheduledStyles = makeStyles(({ breakpoints }) => ({
  container: {
    marginTop: '40px',
  },
  wrapper: {
    width: 'fit-content',
  },
  root: {
    marginBottom: '25px',
    padding: '8px 0 26px 16px',
    flexDirection: 'column',
    background: '#f3f3f3',
    borderBottomRightRadius: '8px',
    borderBottomLeftRadius: '8px',
    [breakpoints.down('xs')]: {
      padding: '8px 16px 26px 16px',
    },
  },
  header: {
    background: '#f3f3f3',
    color: '#444444',
    paddingTop: '16px',
    borderTopRightRadius: '8px',
    borderTopLeftRadius: '8px',
  },
  scheduledDate: {
    fontSize: '1.5rem',
    textAlign: 'center',
  },
  boxProductList: {
    width: 'inherit',
    [breakpoints.down('sm')]: {
      display: 'unset',
    },
  },
  footer: {
    marginTop: '-31px',
    marginBottom: '25px',
    '& button': {
      borderRadius: '0px',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      backgroundColor: '#58c22e',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#3a9e12',
      },
      minHeight: '62px',
      '& .MuiButton-label': {
        '& .MuiTypography-body1': {
          fontSize: '1.5rem',
          fontWeight: 'bold',
          textTransform: 'none',
        },
      },
    },
  },
}));

export { productsAlreadyScheduledStyles };
